import React from 'react';
import {
  Box, List, ListItemButton, ListItemIcon, ListItemText,
  Typography, IconButton, Tooltip, Divider, Chip,
} from '@mui/material';
import {
  Add as AddIcon,
  Storage as DbIcon,
  Circle as CircleIcon,
} from '@mui/icons-material';

const DB_TYPE_COLORS = {
  postgresql: '#336791',
  mysql: '#4479A1',
  mssql: '#CC2927',
  oracle: '#F80000',
  sqlite: '#003B57',
  mongodb: '#47A248',
};

const ConnectionList = ({ connections, selectedId, onSelect, onAdd }) => {
  const internal = connections.find((c) => c.name === '__internal__');
  const external = connections.filter((c) => c.name !== '__internal__');

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="subtitle1" fontWeight="bold">Connections</Typography>
        <Tooltip title="New Connection">
          <IconButton size="small" onClick={onAdd}><AddIcon /></IconButton>
        </Tooltip>
      </Box>
      <Divider />
      <List sx={{ flex: 1, overflow: 'auto' }}>
        {internal && (
          <ListItemButton selected={selectedId === internal.id} onClick={() => onSelect(internal)}>
            <ListItemIcon><DbIcon sx={{ color: DB_TYPE_COLORS.postgresql }} /></ListItemIcon>
            <ListItemText primary="Platform DB" secondary="Internal" />
          </ListItemButton>
        )}
        {internal && external.length > 0 && <Divider />}
        {external.map((conn) => (
          <ListItemButton key={conn.id} selected={selectedId === conn.id} onClick={() => onSelect(conn)}>
            <ListItemIcon><DbIcon sx={{ color: DB_TYPE_COLORS[conn.db_type] || '#666' }} /></ListItemIcon>
            <ListItemText
              primary={conn.name}
              secondary={conn.db_type === 'mongodb' && conn.connection_string ? 'mongodb — connection string' : `${conn.db_type} — ${conn.host}`}
            />
            {conn.restricted && (
              <Tooltip title="Admins only: hidden from other users">
                <Chip label="Restricted" size="small" color="warning" variant="outlined" sx={{ mr: 1 }} />
              </Tooltip>
            )}
            {conn.last_tested_at && (
              <CircleIcon sx={{ fontSize: 10, color: 'success.main' }} />
            )}
          </ListItemButton>
        ))}
        {connections.length === 0 && (
          <Box sx={{ p: 3, textAlign: 'center', opacity: 0.5 }}>
            <Typography variant="body2">No connections yet</Typography>
          </Box>
        )}
      </List>
    </Box>
  );
};

export default ConnectionList;
